import React from "react";

const Instruction = ( {data} ) =>{
    return(
            <div className="flex flex-col rounded-3xl md:p-10 p-5 gap-32 bg-no-repeat bg-contain bg-right-bottom" 
                    style={{backgroundColor: data.instruction.bg_color, backgroundImage: `url("${data.instruction.bg_img}")`}}
                >
                <div className="flex flex-col md:w-[77%] text-pretty gap-4">
                    <span className="font-medium leading-tight lg:text-[56px] md:text-[40px] text-[24px]" 
                            style={{color: data.instruction.title_color}}
                        >
                        {data.instruction.title}
                    </span>
                    <span className="font-medium leading-tight w-[75%] lg:text-[20px] md:text-[18px] text-[14px]" 
                            style={{color: data.instruction.description_color}}
                        >
                        {data.instruction.description}
                    </span>
                </div>

                <button className="flex items-center gap-11 md:px-9 md:py-5 px-6 py-3 w-fit text-nowrap red-custom-button rounded-full" 
                        onClick={() => window.location.replace(data.instruction.button_url_source)}
                    >
                    <span className="font-medium md:text-[20px] text-[12px]" style={{color: data.instruction.button_txt_color}}>
                        {data.instruction.button_txt}
                    </span>
                    <img src={data.instruction.arrow_white} alt="?"/>
                </button>
            </div>
        
    );
};
export default Instruction;